import { createContext } from 'react';

import { Option } from '../../../core';
import { FrontdeskPractitionerFormInputs } from '../types';

interface AdminBookingPractitionerFormContextProps {
  selectedPractitioner?:
    | FrontdeskPractitionerFormInputs
    | Array<FrontdeskPractitionerFormInputs>
    | null;
  values?: FrontdeskPractitionerFormInputs;
  selectedPractitionerOption?: Option | Array<Option> | null;
}

const AdminBookingPractitionerFormContext = createContext<AdminBookingPractitionerFormContextProps>(
  {}
);

export default AdminBookingPractitionerFormContext;
